import React from 'react'
import NavbarContainer from '../components/NavbarContainer/NavbarContainer'
import LoginForm from "../components/LoginForm/LoginForm"
import login from "../assets/logo.png"

function Login() {
  return (
    <div className='vh-100'>
      <NavbarContainer/>
                      <div  className="w-100 h-100 d-flex justify-content-center align-items-center pt-4">
                <div className="login_form_section_container">

        <LoginForm/>
</div>
</div>
    </div>
  )
}

export default Login